// Surface the shared upgrade prompt (same modal the 402 handler triggers) for proactive,
// client-side gating — e.g. when a "New project" button is clicked at the plan's cap.
export function requestUpgrade(message, upgradeUrl = "/plans") {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent("upgrade-required", { detail: { message, upgradeUrl } }));
}
